<template>
  <!-- https://hardware.aeroiot.cn/#/appguide -->
  <div id="appDowloadModule" v-if="appDowloadModuleVisible">
      <div class="aeroiotflex_between">
                <div class="aeroiotflex_row">
                                    <i class="el-icon-close" @click="appDowloadModuleVisible=false"></i>
                <img src="@/assets/downapp.png" alt="" style="width:60px;height:60px">
                <div class="aeroiotflex_col">
                    <div class="aeroiotflex_col1">下载监测云物联网APP</div>
                    <div class="aeroiotflex_col2">工程监测物联网</div>
                </div>
                </div>
                <a href="https://hardware.aeroiot.cn/#/appguide">
                    <div class="downLoadButton aeroiotflex_center">
                        立即下载/打开
                    </div>
                </a>
      </div>
  </div>
</template>

<script>
export default {
    data(){
        return{
            appDowloadModuleVisible:true
        }
    }
}
</script>

<style scoped>
#appDowloadModule{
    position: fixed;
    bottom: 0;
    height: 60px;
    background: rgba(250, 250, 250, 0.9);
    width: 100%;
    z-index: 10;
    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.16);
}
.el-icon-close{
    font-size: 16px;
    cursor: pointer;
    margin: 0 4px 0 17.5px;
}
.aeroiotflex_col1{
    font-size: 13px;
    font-weight: 1000;
    line-height: 18px;
    color: #2D2D2D;
}
.aeroiotflex_col2{
    font-size: 10px;
    font-weight: 400;
    color: #666666;
}
.downLoadButton{
    width: 94px;
    height: 25px;
    background: #2E8EFF;
    border-radius: 50px;
    cursor: pointer;
    font-size: 10px;
    font-weight: 500;
    color: #FFFFFF;
    margin-right: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/appDowloadModule.vue